export type Theme = {
    brand: string
    blue5: string
    blue4: string
    blue3: string
    blue2: string
    blue1: string
    orange5: string
    orange4: string
    orange3: string
    orange2: string
    orange1: string
    gray5: string
    gray4: string
    gray3: string
    gray2: string
    gray1: string
    yellowGreen: string
    green: string
    red: string
    yellow: string
    purple: string
    background: string
    text: string
    border: string
    tableText: string
    tableBorder: string
    tableSubText: string
    tableHeader: string
    white: string
    primary: string
    secondary: string
    danger: string
    warning: string
    success: string
}
export const theme: { light: Theme; dark: Theme } = {
    light: {
        brand: '#1c3267',
        blue5: '#113f93',
        blue4: '#4977d0',
        blue3: '#7898dc',
        blue2: '#a4bae8',
        blue1: '#d1dcf3',
        orange5: '#bf6700',
        orange4: '#cc8627',
        orange3: '#d9a364',
        orange2: '#e6c298',
        orange1: '#f2e0cc',
        gray5: '#2b2b2b',
        gray4: '#555555',
        gray3: '#808080',
        gray2: '#a9a9a9',
        gray1: '#d4d4d4',
        yellowGreen: '#999900',
        green: '#119477',
        red: '#b81151',
        yellow: '#e3bd24',
        purple: '#743ea5',
        background: '#F0FAFE',
        text: '#2b2b2b',
        border: '#2b2b2b',
        tableText: '#113f93',
        tableBorder: '#113f93',
        tableSubText: '#808080',
        tableHeader: '#0081c7',
        white: '#ffffff',
        primary: '#0081c7',
        secondary: '#d6e277',
        danger: '#dc3545',
        warning: '#ffc107',
        success: '#00797B',
    },
    dark: {
        brand: '#1c3267',
        blue5: '#113f93',
        blue4: '#4977d0',
        blue3: '#7898dc',
        blue2: '#a4bae8',
        blue1: '#d1dcf3',
        orange5: '#bf6700',
        orange4: '#cc8627',
        orange3: '#d9a364',
        orange2: '#e6c298',
        orange1: '#f2e0cc',
        gray5: '#2b2b2b',
        gray4: '#555555',
        gray3: '#808080',
        gray2: '#a9a9a9',
        gray1: '#d4d4d4',
        yellowGreen: '#999900',
        green: '#119477',
        red: '#b81151',
        yellow: '#e3bd24',
        purple: '#743ea5',
        background: '#ffffff',
        text: '#2b2b2b',
        border: '#2b2b2b',
        tableText: '#113f93',
        tableBorder: '#113f93',
        tableSubText: '#808080',
        tableHeader: '#7898dc',
        white: '#ffffff',
        primary: '#0081c7',
        secondary: '#d6e277',
        danger: '#dc3545',
        warning: '#ffc107',
        success: '#00797B',
    },
}
